import { isEmpty } from 'shared/utils/objectUtils'

export const isRedPointsActive = (
  toggles: Record<string, string | number | boolean> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, 'redpoints.active')
  ) {
    return true
  }

  return Boolean(toggles['redpoints.active'])
}

export const isHideAboSubscription = (
  toggles: Record<string, string | number | boolean | undefined> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, 'hideAboSubscription')
  ) {
    return false
  }

  return Boolean(toggles['hideAboSubscription'])
}

export const isUserLoginStatusAPIActive = (
  toggles: Record<string, string | number | boolean | undefined> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, 'useUserLoginStatusAPI')
  ) {
    return false
  }

  return Boolean(toggles['useUserLoginStatusAPI'])
}
